import React from 'react';
import ReactDOM from 'react-dom';
import { createStore, combineReducers, applyMiddleware } from 'redux';
import {Provider} from 'react-redux';
import createBrowserHistory from 'history/createBrowserHistory';
import RouteMap from '../router/thefair/routeMap';
import { ConnectedRouter, routerReducer, routerMiddleware} from 'react-router-redux';
import registerServiceWorker from '../registerServiceWorker';
import { composeWithDevTools } from 'redux-devtools-extension';
import Thunk from 'redux-thunk';
import reducers from 'srcRedux/reducers/thefair/index';
import PageLoading from 'components/public/loading/pageLoading';
import ToastLoading from 'components/public/loading/toastLoading';
import Toast from 'components/public/toast';
window.PageLoading = PageLoading;
window.ToastLoading = ToastLoading;
window.Toast = Toast;
PageLoading.show();

const composeEnhancers = composeWithDevTools({
	// Specify name here, actionsBlacklist, actionsCreators and other options if needed
});

const history = createBrowserHistory();
const middleware = routerMiddleware(history);
let initState = {};


const store = createStore(
	combineReducers(Object.assign({},reducers,{
		router: routerReducer
	})),
	initState,
	composeEnhancers(applyMiddleware(Thunk,middleware))
);

let div = document.createElement('div');
div.className='page-container';
document.getElementById('scale-wrapper').appendChild(div);


let sessionStorage = window.sessionStorage || null;
if(sessionStorage){
	sessionStorage.setItem('_entrance_url',window.location.href); //设置入口的链接，用于兼容IOS微信动态签名失效的问题
}

ReactDOM.render(
	<Provider store={store}>
		<ConnectedRouter history={history}>
			<RouteMap history={history} />
		</ConnectedRouter>
	</Provider>,
	div
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index/thefair.js